<page-heading [title]="'integrations.pageTitle' | translate" />

@if (loadingContent) {
<content-loading-list></content-loading-list>
} @if(getModuleWebhook()) {
<div class="row g-3 mb-0">
  @for (card of cards; track $index) { @if (card.visible()) {
  <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
    <div class="card-button-hover h-100">
      <div class="card" [routerLink]="card.route" style="cursor: pointer">
        <div class="card-body">
          <div class="integration-card-icon">
            <div class="icon-wrapper icon-wrapper--official">
              <img
                [src]="card.iconSrc"
                [alt]="card.title"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="integration-card-content">
            <h5 class="card-title">{{ card.title }}</h5>
            <p class="card-text">{{ card.subtitle }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  } }
</div>
}
